import React, { useEffect, useRef, useState } from 'react';
import { useNavigate , useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dateFormat from "dateformat";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import AdminLayout from '../layout/AdminLayout';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { getCreditNoteDetails } from '../../models/CreditNoteModel';
import InvoiceDetails from '../skeletons/InvoiceDetails';
import AddItemModal from '../modals/Invoice/AddItemModal';
import UpdateItemModal from '../modals/Invoice/UpdateItemModal';
import DeleteItemModal from '../modals/Invoice/DeleteItemModal';
import UpdateShippingAddressModal from '../modals/Invoice/UpdateShippingAddressModal';
import { useNotificationCount } from '../../context/NotificationCountContext';
import { decodeHtmlEntities } from '../../helpers/GeneralHelper';
import UpdateCreditNoteModal from '../modals/Invoice/UpdateCreditNoteModal';

function EditCreditNote() {

  const { notificationCount, setNotificationCount } = useNotificationCount();  

  const { theme, toggleTheme } = useTheme();  

  const { state } = useAuth(); 

  let user_data = state.user_data;
  
  const navigate = useNavigate();  
  
  const loader = document.getElementById('loading'); 

  const [modalKey, setModalKey] = useState(0);

  //Update Shipping Address Start
  const [showUpdateShippingAddressModal, setShowUpdateShippingAddressModal] = useState(false);

  const openUpdateShippingAddressModal = () =>{
    setModalKey(prevKey => prevKey + 1); 
    setShowUpdateShippingAddressModal(true);
  } 
  //Update Shipping Address End


  //Add Item Start
  const [showAddItemModal, setShowAddItemModal] = useState(false);

  const openAddItemModal = () =>{
    setModalKey(prevKey => prevKey + 1); 
    setShowAddItemModal(true);
  } 
  //Add Item End


  //Update Item Start
  const [showUpdateItemModal, setShowUpdateItemModal] = useState(false);

  const [itemData, setItemData] = useState({});

  const openUpdateItemModal = (item_data) =>{
    setItemData(item_data);
    setModalKey(prevKey => prevKey + 1); 
    setShowUpdateItemModal(true);
  } 
  //Update Item End


  //Delete Item Start
  const [showDeleteItemModal, setShowDeleteItemModal] = useState(false);

  const openDeleteItemModal = (item_data) =>{
    setItemData(item_data);
    setModalKey(prevKey => prevKey + 1); 
    setShowDeleteItemModal(true);
  } 
  //Delete Item End

  // Update Invoice Details Modal
    const [showUpdateCreditNoteModal, setShowUpdateCreditNoteModal] = useState(false);
    const openUpdateCreditNoteModal = () => {
        setModalKey((prevKey) => prevKey + 1);
        setShowUpdateCreditNoteModal(true);
    };


  const downloadCreditNote = () =>{
    const fileUrl = process.env.REACT_APP_ASSETS_URL+'/pdf/credit-note/'+credit_note_unique_id+'?download=1';
    window.location.href = fileUrl; // Initiates the file download
  }


  // Get Invoice Details Start
  let { credit_note_unique_id } = useParams();

  const [creditNoteLoading, setCreditNoteLoading] = useState(false);
  const [creditNoteData, setCreditNoteData] = useState({});
  const [shippingAddress, setShippingAddress] = useState(null);
  const [creditNoteItems, setCreditNoteItems] = useState([]);
  const [companySettings, setCompanySettings] = useState({});

  const fetchCreditNoteDetails = async (credit_note_unique_id) => {
    setCreditNoteLoading(true);

    try {
        let apiParam = {user_token: user_data.user_token, credit_note_unique_id};
        const response = await getCreditNoteDetails(apiParam);

        if (response.status===true) {
            setCreditNoteData(response.data.credit_note_data);
            setShippingAddress(response.data.credit_note_shipping_address);
            setCreditNoteItems(response.data.credit_note_items);
            setCompanySettings(response.data.company_settings);

            setCreditNoteLoading(false);

            setNotificationCount(localStorage.getItem('unread_notification_count'));
        }
        else if(response.invalid_token===1){
            navigate('/re-login');
        }     
        
    } catch (error) {
        //console.error(error);
    }

  }  

  useEffect(() => {  
    fetchCreditNoteDetails(credit_note_unique_id);
  }, [credit_note_unique_id]);
  // Get Credit Note Details End

  return (
    <>
        <AdminLayout>
            <Helmet>
                <title>Edit Credit Note - Ancile Digital</title>
            </Helmet>
            <div className="main-content app-content">
                <div className="container-fluid">
                    {/* <!-- Page Header --> */}
                    <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                        <h1 className="page-title fw-semibold fs-18 mb-0">Edit Credit Note</h1>
                        <div className="ms-md-1 ms-0">
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item"><a href="javascript:void(0);">Invoice</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Edit Credit Note</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    {/* <!-- Page Header Close --> */}
                    {creditNoteLoading ? (<InvoiceDetails />) : ( 
                    <>
                    {/* <!--Update Shipping Address Modal Start--> */}
                    <UpdateShippingAddressModal
                    showModal={showUpdateShippingAddressModal}
                    setShowModal={setShowUpdateShippingAddressModal}
                    modalKey={modalKey}
                    invoiceData={creditNoteData}
                    setInvoiceData={setCreditNoteData}
                    shippingAddress={shippingAddress}
                    setShippingAddress={setShippingAddress}
                    setInvoiceItems={setCreditNoteItems}
                    setCompanySettings={setCompanySettings} documentKind="credit_note" />
                    {/* <!--Update Shipping Address Modal End--> */}

                    {/* <!--Add Item Modal Start--> */}
                    <AddItemModal
                    showModal={showAddItemModal}
                    setShowModal={setShowAddItemModal}
                    modalKey={modalKey}
                    invoiceData={creditNoteData}
                    setInvoiceData={setCreditNoteData}
                    setShippingAddress={setShippingAddress}
                    setInvoiceItems={setCreditNoteItems}
                    setCompanySettings={setCompanySettings} documentKind="credit_note" />
                    {/* <!--Add Item Modal End--> */}

                    {/* <!--Update Item Modal Start--> */}
                    <UpdateItemModal
                    showModal={showUpdateItemModal}
                    setShowModal={setShowUpdateItemModal}
                    modalKey={modalKey}
                    invoiceData={creditNoteData}
                    itemData={itemData}
                    setInvoiceData={setCreditNoteData}
                    setShippingAddress={setShippingAddress}
                    setInvoiceItems={setCreditNoteItems}
                    setCompanySettings={setCompanySettings} documentKind="credit_note" />
                    {/* <!--Update Item Modal End--> */}

                    {/* <!--Delete Item Modal Start--> */}
                    <DeleteItemModal
                    showModal={showDeleteItemModal}
                    setShowModal={setShowDeleteItemModal}
                    modalKey={modalKey}
                    invoiceData={creditNoteData}
                    itemData={itemData}
                    setInvoiceData={setCreditNoteData}
                    setShippingAddress={setShippingAddress}
                    setInvoiceItems={setCreditNoteItems}
                    setCompanySettings={setCompanySettings} documentKind="credit_note" />
                    {/* <!--Delete Item Modal End--> */}

                    {/* <!--Update Invoice Modal Start--> */}

                    <UpdateCreditNoteModal
                    showModal={showUpdateCreditNoteModal}
                    setShowModal={setShowUpdateCreditNoteModal}
                    modalKey={modalKey}
                    creditNoteData={creditNoteData}
                    setCreditNoteData={setCreditNoteData}
                    />
                    {/* <!--Update Invoice Modal End--> */}
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card custom-card">
                                <div className="card-header d-md-flex d-block">
                                    <div className="h5 mb-0 d-sm-flex d-block align-items-center">
                                        {/* <div className="ms-sm-2 ms-0 mt-sm-0 mt-2 col-auto">
                                            <input type="text" className="form-control form-control-light form-control-sm" value={creditNoteData.project_title} disabled="true" /> 
                                        </div> */}
                                        <div className=" ms-0 mt-sm-0 mt-2 col-auto">
                                            <input type="text" className="form-control form-control-light form-control-sm" value={creditNoteData.credit_note_number} disabled="true" />
                                        </div>
                                    </div>
                                    <div className="ms-auto mt-md-0 mt-2">
                                        <button className="btn btn-sm btn-icon btn-success-light me-2" onClick={downloadCreditNote}>
                                            <i className="bi bi-download"></i>
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row gy-3">
                                        <div className="col-xl-12">
                                            <div className="row">
                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                                    <p className="dw-semibold mb-2" style={{fontWeight: 'bold'}}>
                                                        Billed to :
                                                    </p>
                                                    <div className="row gy-2">
                                                        <div className="col-xl-12">
                                                            {creditNoteData.client_name}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`GSTIN :  ${creditNoteData.client_gstin}`}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {creditNoteData.client_address}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`${'State :'+(creditNoteData.state_name ? creditNoteData.state_name : creditNoteData.client_state_other)}`}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`${'State Code:'+(creditNoteData.state_code ? creditNoteData.state_code : creditNoteData.client_state_code)}`}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`${'Country :'+creditNoteData.country_name}`}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`Pincode : ${creditNoteData.client_pincode}`}
                                                        </div>
                                                        {/* <div className="col-xl-12">
                                                            {creditNoteData.client_email}
                                                        </div> */}
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                                    <p className="dw-semibold mb-2">
                                                        <a href='javascript:void(0);' className='text-primary' onClick={() => openUpdateShippingAddressModal()} style={{fontWeight: 'bold'}}>Shipping To : </a>

                                                        
                                                    </p>
                                                    <div className="row gy-2" style={{display: shippingAddress ? 'block' : 'none'}}>
                                                        <div className="col-xl-12">
                                                            {shippingAddress ? shippingAddress.invoice_company_name : ''}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {shippingAddress ? shippingAddress.address : ''}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`${shippingAddress ? 'City: '+shippingAddress.address_city: ''}`}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`${shippingAddress ? 'State: '+(shippingAddress.state_name ? shippingAddress.state_name : shippingAddress.address_state_other)  : ''}`}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`${shippingAddress ? 'State Code: '+(shippingAddress.state_code ? shippingAddress.state_code : '') : ''}`}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`${shippingAddress ? 'Country: '+shippingAddress.country_name  : ''}`}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`${shippingAddress ? 'Pincode : ' +shippingAddress.address_pincode : ''}`}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 ms-auto mt-sm-0 mt-3">
                                                    <p className="dw-semibold mb-2" style={{fontWeight: 'bold'}}>
                                                        Billing From :
                                                    </p>
                                                    <div className="row gy-2">
                                                        <div className="col-xl-12">
                                                            {companySettings.company_name}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            <div dangerouslySetInnerHTML={{ __html: decodeHtmlEntities(companySettings.company_address) }} />
                                                        </div>
                                                        <div className="col-xl-12 d-none">
                                                            {`PAN : ${companySettings.company_pan}`} 
                                                        </div>
                                                        <div className="col-xl-12 d-none">
                                                            {`CIN : ${companySettings.company_cin}`}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`GSTIN : ${companySettings.company_gst}`}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {`Phone : ${companySettings.company_phone}`}
                                                        </div>
                                                        <div className="col-xl-12">
                                                            {companySettings.company_website}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-12  d-md-flex d-block">
                                            <div className="ms-auto mt-md-0 mt-2">
                                                <button className="btn btn-sm btn-icon btn-danger me-2" onClick={openUpdateCreditNoteModal}>
                                                    <i className="fe fe-edit"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-xl-4"> 
                                            <label htmlFor="invoice-number" className="form-label">Credit note number</label>
                                            <input type="text" className="form-control form-control-light"  value={creditNoteData.credit_note_number} disabled="true" />
                                        </div>
                                        <div className="col-xl-4">
                                            <label htmlFor="invoice-date-issued" className="form-label">Issue date</label>
                                            <input type="text" className="form-control form-control-light" value={dateFormat(creditNoteData.credit_note_bill_date, "dd mmm yyyy")} disabled="true" />
                                        </div>
                                        {creditNoteData.ref_invoice_number ? (
                                        <>
                                        <div className="col-xl-4">
                                            <label className="form-label">Ref. invoice date</label>
                                            <input type="text" className="form-control form-control-light" value={creditNoteData.ref_invoice_bill_date ? dateFormat(creditNoteData.ref_invoice_bill_date, "dd mmm yyyy") : ''} disabled="true" />
                                        </div>
                                        <div className="col-xl-4">
                                            <label className="form-label">Ref. invoice no.</label>
                                            {creditNoteData.ref_invoice_unique_id ? (
                                              <Link to={`/invoices/${creditNoteData.ref_invoice_unique_id}/edit`} className="form-control form-control-light text-primary">
                                                {creditNoteData.ref_invoice_number}
                                              </Link>
                                            ) : (
                                              <input type="text" className="form-control form-control-light" value={creditNoteData.ref_invoice_number} disabled="true" />
                                            )}
                                        </div>
                                        </>
                                        ) : null}
                                        <div className="col-xl-4"> 
                                            <label htmlFor="invoice-due-amount" className="form-label">PO Number</label>
                                            <input type="text" className="form-control form-control-light" value={creditNoteData.credit_note_po_number} />
                                        </div>
                                        <div className="col-xl-4"> 
                                            <label htmlFor="invoice-due-amount" className="form-label">Credit note month</label>
                                            <input type="text" className="form-control form-control-light" value={creditNoteData.credit_note_month} />
                                        </div>
                                        <div className="col-xl-4"> 
                                            <label htmlFor="invoice-due-amount" className="form-label">Amount</label>
                                            <input type="text" className="form-control form-control-light" value={creditNoteData.credit_note_amount} />
                                        </div>
                                        <div className="col-xl-12">
                                            <div className="table-responsive"> 
                                                <table className="table nowrap text-nowrap border mt-3"> 
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Candidate</th>
                                                            <th>SAC</th>
                                                            <th>Rate</th>
                                                            {/* <th>Actual Days</th> */}
                                                            <th>Work Days</th>
                                                            <th>Amount</th>
                                                            <th><i class="bi bi-gear"></i></th> 
                                                        </tr> 
                                                    </thead> 
                                                    <tbody>
                                                        {creditNoteItems && creditNoteItems.map((item, index) => (
                                                        <tr> 
                                                            <td>{index+1}</td>
                                                            <td>
                                                                <div className="form-control form-control-light">{item.item_title}</div>
                                                            </td>
                                                            {/* <td>
                                                                <div className="form-control form-control-light">{item.item_description}</div>
                                                            </td> */}
                                                            <td>
                                                                <div className="form-control form-control-light">{item.item_sac}</div>
                                                            </td>
                                                            <td>
                                                                <div className='form-control form-control-light'>{item.item_rate}</div>
                                                            </td>
                                                            {/* <td>
                                                                <div className='form-control form-control-light'>{item.item_actual_days}</div>
                                                            </td> */}
                                                            <td>
                                                                <div className='form-control form-control-light'>{item.item_work_days}</div>
                                                            </td>
                                                            <td>
                                                                <div className="form-control form-control-light">{item.item_amount_str}</div>
                                                            </td>
                                                            <td>
                                                            <div className="hstack gap-2 fs-15">
                                                                <button type="button" className="btn btn-icon btn-sm btn-info" title="Edit Item" onClick={() => openUpdateItemModal(item)}>
                                                                    <i className='bx bxs-edit'></i>
                                                                </button>
                                        
                                                                <button type="button" className="btn btn-icon btn-sm btn-danger" title="Delete Item" onClick={() => openDeleteItemModal(item)}>
                                                                    <i className='bx bxs-trash'></i>
                                                                </button>
                                                            </div>
                                                            </td>
                                                        </tr> 
                                                        ))}
                                                        <tr>
                                                            <td colspan="7" class="border-bottom-0">
                                                                <a class="btn btn-light" href="javascript:void(0);" onClick={() => openAddItemModal()}><i class="bi bi-plus-lg"></i> Add Item</a>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="3"></td>
                                                            <td colspan="4" >
                                                                <table class="table table-sm text-nowrap mb-0 table-borderless">
                                                                    <tbody>
                                                                        <tr>
                                                                            <th scope="row">
                                                                                <div class="fw-semibold">Sub Total :</div>
                                                                            </th>
                                                                            <td>
                                                                                <input type="text" class="form-control form-control-light invoice-amount-input"  value={creditNoteData.credit_note_amount} />
                                                                            </td>
                                                                        </tr>
                                                                        <tr className={!creditNoteData.credit_note_cgst_tax ? 'd-none' :''}>
                                                                            <th scope="row">
                                                                                <div class="fw-semibold">CGST :</div>
                                                                            </th>
                                                                            <td>
                                                                                <input type="text" class="form-control form-control-light invoice-amount-input" value={creditNoteData.credit_note_cgst_tax} />
                                                                            </td>
                                                                        </tr>
                                                                        <tr className={!creditNoteData.credit_note_sgst_tax ? 'd-none' :''}>
                                                                            <th scope="row">
                                                                                <div class="fw-semibold">SGST :</div>
                                                                            </th>
                                                                            <td>
                                                                                <input type="text" class="form-control form-control-light invoice-amount-input" value={creditNoteData.credit_note_sgst_tax} />
                                                                            </td>
                                                                        </tr>
                                                                        <tr className={!creditNoteData.credit_note_igst_tax==='0:00' ? 'd-none' :''}>
                                                                            <th scope="row">
                                                                                <div class="fw-semibold">IGST :</div>
                                                                            </th>
                                                                            <td>
                                                                                <input type="text" class="form-control form-control-light invoice-amount-input" value={creditNoteData.credit_note_igst_tax} />
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="row">
                                                                                <div class="fs-14 fw-semibold">Total Payable Amount :</div>
                                                                            </th>
                                                                            <td>
                                                                                <input type="text" class="form-control form-control-light invoice-amount-input"  value={creditNoteData.credit_note_total_amount} />
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="row">
                                                                                <div class="fs-14 fw-semibold">Total Paid Amount :</div>
                                                                            </th>
                                                                            <td>
                                                                                <input type="text" class="form-control form-control-light invoice-amount-input"  value={creditNoteData.credit_note_paid_amount} />
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="row">
                                                                                <div class="fs-14 fw-semibold">Balance Due :</div>
                                                                            </th>
                                                                            <td>
                                                                                <input type="text" class="form-control form-control-light invoice-amount-input"  value={creditNoteData.credit_note_balance_due} />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="7" align='right'>
                                                                {creditNoteData.credit_note_total_amount_txt}
                                                            </td>
                                                        </tr>
                                                    </tbody> 
                                                </table> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer text-end">
                                    <Link to={`https://docs.google.com/viewer?url=${encodeURIComponent(process.env.REACT_APP_ASSETS_URL+'/pdf/credit-note/'+credit_note_unique_id)}&embedded=true`} target='_blank' className="btn btn-light me-1"><i className="ri-eye-line me-1 align-middle d-inline-block"></i>Preview PDF</Link>
                                </div>
                            </div>
                        </div>
                    </div>                    </>             
                    )} 
                </div>
            </div>
            <Helmet></Helmet>
        </AdminLayout>
    </>
  )
}
export default EditCreditNote